import React from 'react'

import Layout from '../components/layout'
import WorkOne from '../components/work/WorkOne'
import WorkProjectsShowcase from '../components/work/WorkProjectsShowcase'
import HomeFour from '../components/home/HomeFour'

const Work = props => (
  <Layout
    lang='en'
	title="Work"
	meta={{description: 'We work with great clients, from big corporations to startups that are eager to change the world.'}}
    rootProps={{ className: 'page work' }}
    headerProps={{ isBlue: false }}
  >
    <WorkOne lang="en" />
    <WorkProjectsShowcase lang="en" />
    <HomeFour lang="en" />
  </Layout>
)

export default Work
